export const socialsData = {
    github: 'https://github.com/devsafayet',
    facebook: 'https://www.facebook.com/safayet003.admin/',
    linkedIn: 'https://www.linkedin.com/in/devsafayet/',
    twitter: 'https://twitter.com',
    medium: 'https://medium.com/',
    stackOverflow: 'https://stackoverflow.com/',
    mail: 'mrishafayet003@gmail.com',
}